import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SurveyPage from "./pages/SurveyPage";
import LandingPage from "./pages/LandingPage";
import AdminApp from "./admin/AdminApp";
import AdminDashboard from "./admin/Dashboard";
import AdminResponses from "./admin/Responses";
import AdminDetail from "./admin/Detail";
import AdminAnalysis from "./admin/Analysis";
import AdminGuide from "./admin/Guide";
import AdminSurveys from "./admin/Surveys";
import AdminNewDash from "./admin/NewDash";
import PainDiscoveryDash from "./admin/PainDiscoveryDash";
import MagicApp from "./backoffice/MagicApp";
import MagicFunnelDash from "./backoffice/MagicFunnelDash";
import MagicValidationScoreDash from "./backoffice/MagicValidationScoreDash";
import MagicResponses from "./backoffice/MagicResponses";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/survey/:slug" element={<SurveyPage />} />
        <Route path="/survey" element={<SurveyPage />} />
        <Route path="/backoffice/m/:token" element={<MagicApp />}>
          <Route index element={<MagicFunnelDash />} />
          <Route path="validation-score" element={<MagicValidationScoreDash />} />
          <Route path="responses" element={<MagicResponses />} />
        </Route>
        <Route path="/admin" element={<AdminApp />}>
          <Route index element={<PainDiscoveryDash />} />
          <Route path="legacy" element={<AdminDashboard />} />
          <Route path="responses" element={<AdminResponses />} />
          <Route path="responses/:id" element={<AdminDetail />} />
          <Route path="analysis" element={<AdminAnalysis />} />
          <Route path="new-dash" element={<AdminNewDash />} />
          <Route path="pain-discovery" element={<PainDiscoveryDash />} />
          <Route path="guide" element={<AdminGuide />} />
          <Route path="surveys" element={<AdminSurveys />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
